export default [
  {
    path: "/site",
    name: "site",
    label: "Site",
    component: () => import("@/components/home/MenuSite.vue"),
  },
  {
    path: "/site/banners",
    name: "site.banners",
    label: "Banners",
    component: () => import("@/components/site/banners/lista-de-banners.vue"),
  },
  {
    path: "/site/banners/novo",
    name: "site.banners.novo",
    label: "Adicionar Novo Banner",
    component: () => import("@/components/site/banners/editor-banner.vue"),
  },
  {
    path: "/site/banners/:id/editar",
    name: "site.banners.editar",
    label: "Editar Banner",
    component: () => import("@/components/site/banners/editor-banner.vue"),
  },
  {
    path: "/site/blog",
    name: "site.blog",
    label: "Blog",
    component: () => import("@/components/site/blog/home-blog.vue"),
  },
  {
    path: "/site/blog/posts/gerenciar",
    name: "site.blog.todos-posts",
    label: "Gerenciar Posts",
    component: () => import("@/components/site/blog/lista-de-posts.vue"),
  },
  {
    path: "/site/blog/tags/gerenciar-tags",
    name: "site.blog.tags-gerenciar-tags",
    label: "Gerenciar Tags",
    component: () => import("@/components/site/blog/gerenciar-tags.vue"),
  },
  {
    path: "/site/blog/posts/novo",
    name: "site.blog.adicionar-novo",
    label: "Adicionar Novo Post",
    component: () => import("@/components/site/blog/editor-post.vue"),
  },
  {
    path: "/site/blog/:id/edit",
    name: "site.blog.editar",
    label: "Editar Post",
    component: () => import("@/components/site/blog/editor-post.vue"),
  },
  {
    path: "/site/contato",
    name: "site.contato",
    label: "Contato",
    component: () => import("@/components/site/contato.vue"),
  },
  {
    path: "/site/institucional",
    name: "site.institucional",
    label: "Institucional",
    component: () => import("@/components/site/institucional/home-institucional.vue"),
  },
  {
    path: "/site/institucional/textos",
    name: "site.institucional.site-textos",
    label: "Gerenciar textos do site",
    component: () => import("@/components/site/institucional/gerenciar-textos-site.vue"),
  },
  {
    path: "/site/institucional/sobre-nos",
    name: "site.institucional.sobre-nos",
    label: "Visualizar/Editar Sobre Nós",
    component: () => import("@/components/site/institucional/sobre-nos.vue"),
  },
  {
    path: "/site/institucional/missao-visao-valores",
    name: "site.institucional.missao-visao-valores",
    label: "Visualizar/Editar Missão, Visão e Valores",
    component: () => import("@/components/site/institucional/missao-visao-valores.vue"),
  },
  {
    path: "/site/institucional/meio-ambiente",
    name: "site.institucional.meio-ambiente",
    label: "Visualizar/Editar Meio Ambiente",
    component: () => import("@/components/site/institucional/meio-ambiente.vue"),
  },
  {
    path: "/site/institucional/politica-privacidade",
    name: "site.institucional.politica-privacidade",
    label: "Visualizar/Editar Política de Privacidade",
    component: () => import("@/components/site/institucional/politica-privacidade.vue"),
  },
  {
    path: "/site/produtos",
    name: "site.produtos",
    label: "Produtos",
    component: () => import("@/components/site/produtos/home-produtos.vue"),
  },
  {
    path: "/site/produtos/gerenciar",
    name: "site.produtos.gerenciar",
    label: "Gerenciar Produtos",
    component: () => import("@/components/site/produtos/lista-de-produtos.vue"),
  },
  {
    path: "/site/produtos/add",
    name: "site.produtos.novo",
    label: "Adicionar Novo Produto",
    component: () => import("@/components/site/produtos/editor-produto.vue"),
  },
  {
    path: "/site/produtos/:id/edit",
    name: "site.produtos.editar",
    label: "Editar Produto",
    component: () => import("@/components/site/produtos/editor-produto.vue"),
  },
  {
    path: "/site/produtos/categorias",
    name: "site.produtos.categorias",
    label: "Visualizar Categorias",
    component: () => import("@/components/site/produtos/lista-de-categorias.vue"),
  },
  {
    path: "/site/produtos/categorias/novo",
    name: "site.produtos.categorias.novo",
    label: "Adicionar Nova Categoria",
    component: () => import("@/components/site/produtos/editor-categoria.vue"),
  },
  {
    path: "/site/produtos/categorias/:id/edit",
    name: "site.produtos.categorias.editar",
    label: "Editar Categoria",
    component: () => import("@/components/site/produtos/editor-categoria.vue"),
  },
  {
    path: "/site/produtos/subcategorias",
    name: "site.produtos.subcategorias",
    label: "Visualizar Subcategorias",
    component: () => import("@/components/site/produtos/lista-de-subcategorias.vue"),
  },
  {
    path: "/site/subcategorias/novo",
    name: "site.produtos.subcategorias.novo",
    label: "Adicionar Nova Subcategoria",
    component: () => import("@/components/site/produtos/editor-subcategoria.vue"),
  },
  {
    path: "/site/subcategorias/:id/edit",
    name: "site.produtos.subcategorias.editar",
    label: "Editar Subcategoria",
    component: () => import("@/components/site/produtos/editor-subcategoria.vue"),
  },
  {
    path: "/site/simuladores/cadastro-cores/novo",
    name: "site.simuladores.cores.novo",
    label: "Adicionar Nova Cor",
    component: () => import("@/components/site/simuladores/form-simulador-ambiente-cores.vue"),
  },
  {
    path: "/site/simuladores/cadastro-cores/:id",
    name: "site.simuladores.cores.editar",
    label: "Editar Cor",
    component: () => import("@/components/site/simuladores/form-simulador-ambiente-cores.vue"),
  },
  {
    path: "/site/simuladores/cores",
    name: "site.simuladores.cores",
    label: "Visualizar Cores",
    component: () => import("@/components/site/simuladores/simulador-ambiente-cores.vue"),
  },
  {
    path: "/site/simuladores/cadastro-imagens/novo",
    name: "site.simuladores.imagens.novo",
    label: "Adicionar Nova Imagem",
    component: () => import("@/components/site/simuladores/form-simulador-ambiente-imagens.vue"),
  },
  {
    path: "/site/simuladores/cadastro-imagens/:id",
    name: "site.simuladores.imagem.editar",
    label: "Editar Imagem",
    component: () => import("@/components/site/simuladores/form-simulador-ambiente-imagens.vue"),
  },
  {
    path: "/site/simuladores/imagens",
    name: "site.simuladores.imagens",
    label: "Visualizar Imagens",
    component: () => import("@/components/site/simuladores/simulador-ambiente-imagens.vue"),
  },
  {
    path: "/site/simuladores",
    name: "site.simuladores",
    label: "Simuladores de Ambientes",
    component: () => import("@/components/site/simuladores/HomeSimuladores.vue"),
  },
];
